import React from 'react'
import { Link } from 'react-router-dom'
import Card from 'react-bootstrap/Card'
import Table from 'react-bootstrap/Table'
import TableLoader from '@components/TableLoader/TableLoader'
import camelCaseToTitle from '@utils/camel-case-to-title'

function DetailsTable({ invoice, fields, loading }) {
  return (
    <Card>
      <Card.Header>Invoice Details</Card.Header>
      <Table responsive bordered hover striped className='card-table'>
        {loading ? (
          <TableLoader />
        ) : (
          <tbody>
            { fields.map((field) => (
              <tr key={field}>
                <th className='col-lg-3'>{camelCaseToTitle(field)}</th>
                <td>{invoice[field]}</td>
              </tr>
            ))}
            <tr>
              <th className='col-lg-3'>Merchant</th>
              <td>
                <Link to={`/merchants/${invoice.merchant.id}`}>
                  {invoice.merchant.name || invoice.merchant.id}
                </Link>
              </td>
            </tr>
          </tbody>
        )}
      </Table>
    </Card>
  )
}

export default DetailsTable
